import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional Tailwind class joiner. Uses `clsx` for conditional/array sugar
 * and `tailwind-merge` to dedupe conflicting utilities (last one wins, e.g.
 * trailing `text-red-500` overrides an earlier `text-blue-500`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
